import { render, staticRenderFns } from "./BusinessVisitorVisaView.vue?vue&type=template&id=e2c361a8&scoped=true"
import script from "./BusinessVisitorVisaView.vue?vue&type=script&lang=js"
export * from "./BusinessVisitorVisaView.vue?vue&type=script&lang=js"
import style0 from "./BusinessVisitorVisaView.vue?vue&type=style&index=0&id=e2c361a8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2c361a8",
  null
  
)

export default component.exports